export default function numberFormatter(number: number) {
  let num = number || 0;
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
